// =============================================================================
// FILE:
// frontend/src/modules/pms/services/projectSiteStoreService.js
// =============================================================================

import axiosClient from "../../../api/axiosClient";


// =============================================================================
// GET SITE STORE BY PROJECT
// =============================================================================

export const getProjectSiteStores = (
  projectId
) => {

  return axiosClient.get(

    `/api/pms/project-site-store/by-project/${projectId}`
  );
};